// The daily background, in the browser. The rule that picks the image moved
// to shared/background.ts on 2 Aug 2026 so the server-rendered Crossfire
// pages can show the same one; what is left here is the part that needs a
// DOM. Re-exported rather than re-pointed at every call site, because the
// import is the same fact wherever it is read from.
import type { Background } from "../shared/background.js";
import { artUrl } from "./assets.js";

export { backgroundFor, dayOfYear } from "../shared/background.js";
export type { Background, RotationEntry } from "../shared/background.js";

// Both modes of the active day only, so the theme toggle crossfades with no
// network wait; neighbouring days stay out of the critical path on purpose.
//
// Through artUrl, the same as the layers that paint it (4 Aug 2026). A
// backgroundFor path is a stored path, `/backgrounds/<file>`, and stored paths
// stopped being fetchable from this origin when the tree moved to the bucket:
// the app answers them 404 and the CDN in front of it 403s. Preloading the raw
// path therefore warmed nothing and cost two failed requests on every load,
// while the layers in Background.tsx went to the bucket through artCss and
// fetched the images a second time. The failure was invisible from the page,
// which is why it survived the move: the picture still appeared, just never
// from the cache this function exists to fill.
export function preloadBackground(bg: Background): void {
  for (const url of [bg.light, bg.dark]) {
    const img = new Image();
    img.src = artUrl(url);
  }
}
